import { type Ref, computed, shallowRef, toRef, unref, watch } from "vue";

export default function useShadowModel<
  K extends string,
  P extends { [key in K]: unknown },
  E extends (e: `update:${K}`, v: P[K]) => unknown,
>(propName: K, props: P, emit: E): Ref<P[K]> {
  const prop = toRef(props, propName);
  const shadow = shallowRef(prop.value);

  watch(prop, (newValue) => {
    shadow.value = unref(newValue);
  });

  return computed({
    get: () => shadow.value,
    set(newValue) {
      shadow.value = newValue;
      emit(`update:${propName}`, newValue);
    },
  });
}
